export default "__VITE_ASSET__BNJH3vJd__"